import React from 'react';
import { Image, View } from 'react-native';
import { Text } from 'react-native-web';
import FullPageSimulator from '../FullPageSimulator';
import PhoneHeadLineWithBackgroundColor from '../../AuxiliaryComponent/MixComponent/PhoneHeadLineWithBackgroundColor';
import ScrollViewWithContactLines from '../../AuxiliaryComponent/MixComponent/ScrollViewWithContactLines';
import { Android, successInputTextPerFlow } from '../../../../utils/DictionaryManagementUtils';
import { img_typing_ios } from '../../../../utils/ImagesManagementUtils';

//= ========================================================================
const AccountTransactionFP = ({
  globJSON,
  language,
  simPlatform,
  withTwoPoints,
  TopTitle,
  withHeadTitleLine,
  slideshowRefs,
  transactionsList,
  subCategory,
}) => {
  const myStyles = {
    typingImage: {
      width: 240,
      height: 28,
      marginTop: 206,
    },
    InputTextPerFlowStyle: {
      position: 'absolute',
      fontSize: 10.4,
      marginTop: 212,
      marginLeft: 40,
    },
    imageTyping: {
      position: 'absolute',
      width: '100%',
    },
  };

  return (
    <View>
      <FullPageSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        TopTitle={TopTitle}
        hidePhoneHeadLine
        slideshowRefs={slideshowRefs}
        floatingChildrenTop={(
          <PhoneHeadLineWithBackgroundColor
            globJSON={globJSON}
            simPlatform={simPlatform}
            language={language}
            withTwoPoints={withTwoPoints}
          />
            )}
      >
        <ScrollViewWithContactLines
          globJSON={globJSON}
          simPlatform={simPlatform}
          withHeadTitleLine={withHeadTitleLine}
          transactionsList={transactionsList}
        />
      </FullPageSimulator>
      {simPlatform !== Android
            && (
            <View style={myStyles.imageTyping}>
              <Image
                fadeDuration={0}
                style={myStyles.typingImage}
                source={img_typing_ios}
              />
              <Text style={myStyles.InputTextPerFlowStyle}>{successInputTextPerFlow[subCategory]}</Text>
            </View>
            )}
    </View>
  );
};

export default AccountTransactionFP;
